import script from "./PluginList.vue?vue&type=script&setup=true&lang=js"
export * from "./PluginList.vue?vue&type=script&setup=true&lang=js"

import "./PluginList.vue?vue&type=style&index=0&id=126b098a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126b098a"]])

export default __exports__